import React from "react"
import {PaginationActions, SbPaginatedDatagrid} from "components/commons"
import getUserTableColumns from "./user-table-columns"
import {
    MicrojobberRequest,
    OrderType, PaginatedResponse,
    SearchFilter, Users,
} from "models"

interface UserTableProps
{
    handleCallback: (data: SearchFilter) => void
    data: PaginatedResponse<Users>
    onToggleSuperAdmin?: (accountId: string, isSuperAdmin: boolean) => void
}
interface UserTableState
{
    pagination: SearchFilter
}
export class UserTable extends React.Component<UserTableProps, UserTableState>
{
    private readonly columns: any

    constructor(props: UserTableProps)
    {
        super(props)
        this.columns = getUserTableColumns(this.props.onToggleSuperAdmin)
        this.state = {
            pagination: {
                pageSize: 10,
                pageId: 0,
                orderBy: "id",
                orderType: OrderType.ASCENDING,
            },
        }
    }

    componentDidMount()
    {
        this.props.handleCallback(this.state.pagination)
    }

    private onPaginationChanged = (pageId: number, pageSize: number): void => {
        this.setState(
            () => ({
                pagination: {
                    ...this.state.pagination,
                    pageSize: pageSize,
                    pageId: pageId,
                },
            }),
            () => this.props.handleCallback(this.state.pagination as MicrojobberRequest)
        )
    }

    private onSortChanged = (orderBy: string|null, orderType: OrderType|null): void => {
        // this.setState(
        //     () => ({
        //         pagination: {
        //             pageSize: this.state.pagination.pageSize,
        //             pageId: this.state.pagination.pageId,
        //             orderBy: orderBy,
        //             orderType: orderType,
        //         },
        //     }),
        //     () => this.props.handleCallback(this.state.pagination as MicrojobberRequest)
        // )
    }

    render()
    {
        return (
            <SbPaginatedDatagrid
                columns={this.columns}
                data={this.props.data}
                pagination={this.state.pagination}
                onPaginationChanged={this.onPaginationChanged}
                onSortChanged={this.onSortChanged}
            />
        )
    }
}
